const prefix = "SANDBOX_";

export const CREATE = prefix + "CREATE";
export const DELETE = prefix + "DELETE";
export const LOAD_ORIGINAL_LEVY_COLLECTION = prefix + "LOAD_ORIGINAL_LEVY_COLLECTION";
